import React, { useEffect, useState } from 'react';

const StatusSelection = (props) => {
    const { radio } = props;
    const [selection, setSelection] = useState(radio.n_selection);

    useEffect(() => {
        const update = () => {
            setSelection(radio.n_selection);
        };
        radio.addListener(update);
        return () => {
            radio.listeners = radio.listeners.filter((listener) => listener !== update);
        };
    }, [radio]);

    const visibleStatuses = (() => {
        const filteredStatuses = Object.values(radio.status).filter(
            (status) => Number(status.code) !== 0,
        );

        const selectedIndex = filteredStatuses.findIndex((status) => Number(status.code) === selection);

        let start = Math.max(0, selectedIndex - 2);
        let end = Math.min(filteredStatuses.length, selectedIndex + 3);

        if (end - start < 5) {
            if (start === 0) {
                end = Math.min(filteredStatuses.length, 5);
            } else if (end === filteredStatuses.length) {
                start = Math.max(0, filteredStatuses.length - 5);
            }
        }

        return filteredStatuses.slice(start, end);
    })();

    return (
        <div className="col">
            {visibleStatuses.map((status) => (
                <div key={status.code}>
                    <div
                        className={`bg-${selection === Number(status.code) ? 'dark text-light' : 'light'}`}
                        id={`option_${status.code}`}
                    >
                        {status.code} - {status.name}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default StatusSelection;
